import { render, staticRenderFns } from "./singleAllocation.vue?vue&type=template&id=3fe30583&scoped=true&"
import script from "./singleAllocation.vue?vue&type=script&lang=js&"
export * from "./singleAllocation.vue?vue&type=script&lang=js&"
import style0 from "./singleAllocation.vue?vue&type=style&index=0&id=3fe30583&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe30583",
  null
  
)

export default component.exports